import * as actions from "../actions_agent/Type";
const intialState = {
  list_each_project: [],
  list_all_projects: [],
  list_project_by_id: [],
  list_realestate_project: [],
  view_projects: {},
  view_each_shuqa: {},
  view_list_vella_project: [],
  view_each_vella: {},
};
const ProjectReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.GET_LIST_PROJECTS:
      return {
        ...state,
        list_all_projects: action.payload,
      };
    case actions.GET_ONE_PROJECT:
      return {
        ...state,
        list_each_project: action.payload,
      };
    case actions.UPDATE_SHUQA:
      return {
        ...state,
      };
    case actions.GET_LIST_PROJECTS_BYID:
      return {
        ...state,
        list_project_by_id: action.payload,
      };
    case actions.GET_PROJECTS_RE:
      return {
        ...state,
        list_realestate_project: action.payload,
      };
    case actions.VIEW_PROJECTS:
      return {
        ...state,
        view_projects: action.payload,
      };
    case actions.VIEW_DETAIL_EACH_SHUQA:
      return {
        ...state,
        view_each_shuqa: action.payload,
      };
    case actions.VIEW_VELLA_PROJECTS:
      return {
        ...state,
        view_list_vella_project: action.payload,
      };
    case actions.VIEW_DETAIL_EACH_VELLA:
      return {
        ...state,
        view_each_vella: action.payload,
      };
    case actions.CANCEL_BILL_PROJECT:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default ProjectReducer;
